import axios from 'axios'
import { MobileLoadAccessMinimumPlan, MobileLoadHiddenFieldGroup } from '@numeo/types-core'

interface Envelope<T> {
    success: boolean
    data: T
}

export interface MobileLoadAccessPolicy {
    _id: string
    mcNumber: string
    normalizedMc: string
    label?: string
    minimumPlan: MobileLoadAccessMinimumPlan
    hiddenFieldGroups: MobileLoadHiddenFieldGroup[]
    enabled: boolean
    revision: number
    createdAt: string
    createdBy: string
    updatedAt: string
    updatedBy: string
}

export type MobileLoadAccessPolicyInput = Pick<MobileLoadAccessPolicy, 'mcNumber' | 'minimumPlan' | 'hiddenFieldGroups' | 'enabled'> & {
    label?: string
}

export interface MobileLoadAccessHistoryEntry {
    _id: string
    policyId: string
    action: 'create' | 'update' | 'delete'
    operator: string
    createdAt: string
    before: MobileLoadAccessPolicy | null
    after: MobileLoadAccessPolicy | null
}

export const mobileLoadAccessApi = {
    async listPolicies(): Promise<MobileLoadAccessPolicy[]> {
        const response = await axios.get<Envelope<{ items: MobileLoadAccessPolicy[] }>>('/gluon/mobile-load-access-policies')
        return response.data.data.items
    },

    async createPolicy(input: MobileLoadAccessPolicyInput): Promise<MobileLoadAccessPolicy> {
        const response = await axios.post<Envelope<{ policy: MobileLoadAccessPolicy }>>('/gluon/mobile-load-access-policies', input)
        return response.data.data.policy
    },

    async updatePolicy(id: string, input: MobileLoadAccessPolicyInput): Promise<MobileLoadAccessPolicy> {
        const response = await axios.put<Envelope<{ policy: MobileLoadAccessPolicy }>>(`/gluon/mobile-load-access-policies/${id}`, input)
        return response.data.data.policy
    },

    async deletePolicy(id: string): Promise<void> {
        await axios.delete(`/gluon/mobile-load-access-policies/${id}`)
    },

    async getPolicyHistory(id: string): Promise<MobileLoadAccessHistoryEntry[]> {
        const response = await axios.get<Envelope<{ items: MobileLoadAccessHistoryEntry[] }>>(`/gluon/mobile-load-access-policies/${id}/history`)
        return response.data.data.items
    },
}

export function mobileLoadAccessErrorMessage(error: unknown, fallback: string): string {
    if (axios.isAxiosError(error)) {
        const message = (error.response?.data as { message?: string } | undefined)?.message
        if (message) return message
    }
    return error instanceof Error ? error.message : fallback
}
